import React from 'react';
import { saveAs } from 'file-saver';
import './Notice.css'; // Ensure the CSS file is imported

const Notice = () => {
  const data = [
    {
      id: 1,
      notice: 'Notice IQAC',
      download: '/Notice/Notice-IQAC.pdf',
    },
    {
      id: 2,
      notice: 'Alumni Meet',
      download: '/Notice/Alumni-meet.pdf',
    },
    {
      id: 3,
      notice: 'FDP',
      download: '/Notice/FDP.pdf',
    },
    {
      id: 4,
      notice: 'List of Participants',
      download: '/Notice/List of Participants.pdf',
    },
    {
      id: 5,
      notice: 'Blood Donation Camp',
      download: '/Notice/DocScanner Apr 10, 2025 10.13.pdf',
    },
    {
      id: 6,
      notice: 'Industrial Visit',
      download: '/Notice/Industrial Visit.pdf',
    },
    {
      id: 7,
      notice: 'Industrial Visit Report',
      download: '/Notice/Industrial Visit Report.pdf',
    },
    {
      id: 8,
      notice: 'PTM 2024',
      download: '/Notice/ptm 24.pdf',
    },
    {
      id: 9,
      notice: 'PTM 2025',
      download: '/Notice/ptm25.pdf',
    },
    {
      id: 10,
      notice: 'PTM Images 2025',
      download: '/Notice/ptm image pdf.pdf',
    },
  ];

  const handleDownload = (fileUrl) => {
    saveAs(fileUrl);
  };

  return (
    <div className="container-download-content">
      <h1>Notice</h1>
      <div className="table-wrapper">
        <table className="download-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Notice</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.notice}</td>
                <td>
                  <button
                    onClick={() => handleDownload(item.download)}
                    className="primary-button"
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Notice;
